import { auth } from '../de/auth/index';
import { homes } from '../de/homes/index';
import { administration } from '../de/administration/index';
import { tests } from '../de/tests/index';
import { users } from '../de/users/index';
import { dashboard } from '../de/dashboard';
import { training } from '../de/training/index';
import { reports } from '../de/reports/index';

// Messages for EN language
const strings = {
    appName: 'Watt Analytics',
    loading: 'Laden...',
    language: {
        sk: 'Slowakisch',
        en: 'English',
        de: 'Deutsch',
        zh: '中文'
    },
    ok: 'OK',
    add: 'Hinzufügen',
    permissionsIsAdminTag: 'Administrator',
    permissionsIsNotAdminTag: 'Benutzer',
    permissionsIsTesterTag: 'Tester',
    permissionsIsInstallerTag: 'Installer',
    select: 'Auswählen',
    save: 'Speichern',
    download: 'Herunterladen',
    close: 'Schließen',
    version: 'Version',
    reload: 'Neu laden',
    edit: 'Bearbeiten',
    invite: 'Einladen',
    adminAddUser: 'Besitzer hinzufügen',
    cancel: 'Abbrechen',
    delete: 'Löschen',
    undelete: 'Wiederherstellen',
    sureToUndeleteTitle: 'Sind sie sicher, dass sie diesen Datensatz wiederherstellen wollen?',
    sureToDeleteTitle: 'Sind sie sicher, dass sie diesen Datensatz löschen wollen?',
    maxLengthReached: 'Maximale Länge erreicht.',
    actionsLabel: 'Aktionen',
    logoutLink: 'Abmelden',
    dashboardRoute: 'Anzeige',
    noDataAvailable: 'keine Daten',
    emailFormatField: 'Die Email-Adresse hate ein falsches Format.',
    requiredField: 'Diese Feld ist zwingend erforderlich',
    msgErrorApi: 'Fehler beim Auslesen der Daten',
    perMinute: 'pro min.',
    id: 'ID',
    auth,
    users,
    administration,
    tests,
    homes,
    dashboard,
    training,
    reports
};

export default strings;
